import React from 'react';

import { IIconProps, TIconType } from '../interface';

const PolygonIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-id='icon-button'
			data-testid='polygon'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M11.25 6.75C12.4926 6.75 13.5 5.74264 13.5 4.5C13.5 3.25736 12.4926 2.25 11.25 2.25C10.0074 2.25 9 3.25736 9 4.5C9 5.74264 10.0074 6.75 11.25 6.75Z'
				data-id='icon-button'
				fill='currentColor'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'

			/>
			<path
				d='M3.75 13.5C4.99264 13.5 6 12.4926 6 11.25C6 10.0074 4.99264 9 3.75 9C2.50736 9 1.5 10.0074 1.5 11.25C1.5 12.4926 2.50736 13.5 3.75 13.5Z'
				data-id='icon-button'
				fill='currentColor'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M15 21.75C16.2426 21.75 17.25 20.7426 17.25 19.5C17.25 18.2574 16.2426 17.25 15 17.25C13.7574 17.25 12.75 18.2574 12.75 19.5C12.75 20.7426 13.7574 21.75 15 21.75Z'
				data-id='icon-button'
				fill='currentColor'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M19.5 9C20.7426 9 21.75 7.99264 21.75 6.75C21.75 5.50736 20.7426 4.5 19.5 4.5C18.2574 4.5 17.25 5.50736 17.25 6.75C17.25 7.99264 18.2574 9 19.5 9Z'
				data-id='icon-button'
				fill='currentColor'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M17.325 6.15938L13.425 5.09063'
				data-id='icon-button'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.58126 6.00938L5.41876 9.74063'
				data-id='icon-button'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M5.56876 12.5812L13.1813 18.1687'
				data-id='icon-button'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M15.75 17.3813L18.75 8.86875'
				data-id='icon-button'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default PolygonIcon;
